import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getFeaturedShow } from './redux/actions';
import { selectList, selectShow } from './redux/selectors';
import ShowDescription from './common/ShowDescription';
import NextEpisode from './common/NextEpisode';
import Icon from '../../common/icons/Icon';

class Shows extends Component {
  static propTypes = {
    shows: PropTypes.array.isRequired,
    featuredShowLoaded: PropTypes.bool.isRequired,
    featuredShow: PropTypes.object,
    history: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.props.dispatch(getFeaturedShow());
  }

  handlePlay = showId => {
    this.props.history.push(`/subscription/tv/${showId}?featured`);
  };

  renderHero = () => {
    const { featuredShow: show } = this.props;

    if (!show) {
      return null;
    }

    return (
      <div className="hero__wrapper" style={show.image ? { backgroundImage: `url(${show.image.location})` } : null}>
        <div className="container">
          <div className="tv__hero">
            <Icon icon="TvLogo" className="ttv-logo" />
            <div className="show__title">
              <h1>{show.name}</h1>
              <NextEpisode time={show.next_episode} />
            </div>
            <p>{show.description}</p>
            <div className="tv__hero__buttons">
              <button type="button" className="button button--icon" onClick={this.handlePlay.bind(this, show.id)}>
                <Icon icon="PlayCircle" />Play
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderShowList = () => {
    if (!this.props.shows.length) {
      return null;
    }

    const shows = this.props.shows.map(show => (
      <ShowDescription
        key={show.id}
        id={show.id}
        name={show.name}
        description={show.description}
        image={show.image.location}
        nextEpisode={show.next_episode}
      />
    ));

    return (
      <div className="show__list">
        <div className="container">
          <h3>All Shows</h3>
          <div className="shows__wrapper">{shows}</div>
        </div>
      </div>
    );
  };

  render() {
    const { featuredShowLoaded } = this.props;

    const hero = featuredShowLoaded ? this.renderHero() : null;

    return (
      <div>
        {hero}
        {this.renderShowList()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  shows: selectList(state.subscription.tv.shows),
  featuredShowLoaded: state.subscription.tv.featuredShow.get('loaded'),
  featuredShow: selectShow(state.subscription.tv.featuredShow),
});

export default connect(mapStateToProps)(withRouter(Shows));



// WEBPACK FOOTER //
// ./src/subscription/tv/Shows.js